const CourierTitle = ({ record }) => <span>{record.name}</span>;

export default CourierTitle;
